import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
import { createRegister } from "../../services/RegisterService";
import {
  CONFIRMED_CREATE_REGISTER_ACTION,
  FAILED_CREATE_REGISTER_ACTION,
} from "../actions/RegisterType";

// Helper to get auth token
function getAuthToken(getState) {
  // const stateToken = getState().auth?.authKey;
  // if (stateToken) return stateToken;

  const token = localStorage.getItem("token");
  console.log("token Action->", token);
  return token;
}

export function createRegisterAction(formData) {
  return async (dispatch, getState) => {
    try {
      const registerData = {
        disease_id: formData.disease_id || "", 
        first_name: formData.first_name,
        middile_name: formData.middle_name || '',
        last_name: formData.lastname,
        patient_email: formData.email || '',
        whatsapp_contact_no: formData.contact_number,
        gender: formData.gender,
        date_of_birth: formData.date_of_birth,
        height: formData.height || '',
        weight: formData.weight || '',
        occupation: formData.occupation || '',
      };

      console.log("Sending register data:", registerData);

      const response = await createRegister(registerData);
      console.log("Register API response:", response?.data);

      if (response?.data?.status === "success" && response?.data?.data?.patient_id) {
        const register_id = response.data.data.patient_id;

        dispatch({
          type: CONFIRMED_CREATE_REGISTER_ACTION,
          payload: response.data.data,
        });

        handleSuccess("Registration completed successfully! Kindly check your email for further details!");
        return { register_id };
      } else {
        throw new Error(response?.data?.message || "Failed to register user");
      }
    } catch (error) {
      console.error("Create register error:", error);

      dispatch({
        type: FAILED_CREATE_REGISTER_ACTION,
        payload: error.message,
      });

      showErrorAlert("Error", error.message);

      throw error;
    }
  };
}
